import Proptypes from 'prop-types'
import { registryDiscountPath } from 'lib/urls'

const DiscountDisclaimer = () => (
  <a
    href={registryDiscountPath}
    className="tiny"
    target="_blank"
    rel="noopener noreferrer"
  >
    **Restrictions may apply.
  </a>
)

export const ShippingDisclaimer = ({ className }) => (
  <a
    href="https://help.babylist.com/hc/en-us/articles/217912848-How-much-is-shipping-at-the-Babylist-store-"
    className={`tiny ${className}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{ display: 'inline-block' }}
  >
    *Restrictions may apply. Not all products are eligible. Handling and
    location surcharges may apply.
  </a>
)

ShippingDisclaimer.propTypes = {
  className: Proptypes.string,
}

ShippingDisclaimer.defaultProps = {
  className: '',
}

const Disclaimers = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <DiscountDisclaimer />
      <br />
      <ShippingDisclaimer />
    </div>
  )
}

export default Disclaimers
